(function () {
  var rfqStarted = {};
  var rfqSubmitAttempted = {};
  var rfqSubmitted = {};

  function getFormApp(target) {
    if (!target || !target.closest) return null;

    return target.closest('.globo-form-app');
  }

  function getFormInfo(target) {
    var app = getFormApp(target);
    if (!app) return null;

    var formId = app.getAttribute('data-id');
    if (!formId) return null;

    var form = app.querySelector(
      'form[data-id="' + formId + '"]'
    );

    if (!form) return null;

    return {
      app: app,
      form: form,
      formId: formId
    };
  }

  function getFormLocation() {
    if (window.location.pathname === '/pages/contact-us') {
      return 'contact_page';
    }

    if (window.location.pathname.indexOf('/products/') === 0) {
      return 'product_page';
    }

    return '';
  }

  function isFormControl(target) {
    return (
      target &&
      target.matches &&
      target.matches(
        'input:not([type="hidden"]), textarea, select'
      )
    );
  }

  function publishRfqStart(info) {
    if (!info) return;
    if (rfqStarted[info.formId]) return;

    rfqStarted[info.formId] = true;

    Shopify.analytics.publish('studson:rfq_form_start', {
      form_id: info.formId,
      form_location: getFormLocation()
    });

    console.log('[RFQ] start', info.formId);
  }

  function publishRfqSubmit(info) {
    if (!info) return;
    if (rfqSubmitted[info.formId]) return;

    rfqSubmitted[info.formId] = true;

    Shopify.analytics.publish('studson:rfq_form_submit', {
      form_id: info.formId,
      form_location: getFormLocation()
    });
    //window.lintrk('track', { conversion_id: 29725434 });
    if (typeof window.lintrk === 'function') {
      window.lintrk('track', { conversion_id: 29725434 });
    }

    console.log('[RFQ] submit success', info.formId);
  }

  // ------------------------------------------------------
  // FORM START
  // click into field OR tab into field
  // ------------------------------------------------------

  document.addEventListener('focusin', function (event) {
    if (!event.isTrusted) return;
    if (!isFormControl(event.target)) return;

    var info = getFormInfo(event.target);
    if (!info) return;

    publishRfqStart(info);
  }, true);

  // ------------------------------------------------------
  // SUBMIT ATTEMPT
  // Do NOT send GA4 yet
  // ------------------------------------------------------

  document.addEventListener('submit', function (event) {
    var info = getFormInfo(event.target);
    if (!info) return;

    rfqSubmitAttempted[info.formId] = true;

    console.log('[RFQ] submit attempted', info.formId);
  }, true);

  // ------------------------------------------------------
  // CHECK SUCCESS
  // ------------------------------------------------------

  function checkSuccess(app) {
    var formId = app.getAttribute('data-id');
    if (!formId) return;

    // User must have attempted submit first
    if (!rfqSubmitAttempted[formId]) return;

    if (rfqSubmitted[formId]) return;

    var success = app.querySelector('.message.success');
    if (!success) return;

    var style = window.getComputedStyle(success);

    var visible =
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      success.getClientRects().length > 0;

    if (!visible) return;

    var form = app.querySelector(
      'form[data-id="' + formId + '"]'
    );

    if (!form) return;

    publishRfqSubmit({
      app: app,
      form: form,
      formId: formId
    });
  }

  function observeFormApp(app) {
    if (app.dataset.rfqTrackingInitialized === 'true') {
      return;
    }

    app.dataset.rfqTrackingInitialized = 'true';

    var observer = new MutationObserver(function () {
      checkSuccess(app);
    });

    observer.observe(app, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });

    checkSuccess(app);
  }

  function initRfqTracking() {
    document
      .querySelectorAll('.globo-form-app')
      .forEach(function (app) {
        observeFormApp(app);
      });
  }

  initRfqTracking();

  // Globo may render form asynchronously
  var pageObserver = new MutationObserver(function () {
    initRfqTracking();
  });

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();